import instance from '../api/interceptor';

export const FileService = {
  async createImage(file) {
    const formData = new FormData();
    formData.append('image', file);
    return instance.post('/files', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  async isExist(data) {
    return instance.post('/files/exist', { name: data });
  },

  async poseEstimation(file) {
    const formData = new FormData();
    formData.append('image', file);
    return instance.post('/pose-estimation', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};
